import { Flex, Text, Center } from "@chakra-ui/react";

import Error from "../src/components/common/error";
import TopBand from "../src/components/common/topBand";
import LocationMap from "../src/components/locationMap";

import { wrapper } from "../src/redux/store";
import { fetchProductCategories } from "../src/redux/actions";

export default function ContactUs({ errorMessage }) {
  if (errorMessage) {
    return <Error errorMessage={errorMessage} />;
  }
  return (
    <>
      <TopBand title="Contact Us" />
      <Center my="10" width="100%">
        <Flex
          flexWrap="wrap"
          width={{ base: "90%", "2xl": "1350px" }}
          justifyContent={{ base: "center", xl: "space-between" }}
        >
          <Flex
            p="20px"
            borderWidth={1}
            flexDirection="column"
            // borderColor="cartItemBorder"
            width={{ base: "100%", xl: "48%" }}
          >
            <Flex width={{ base: "100%", md: "48%" }} flexDirection="column">
              <Text variant="contactUsBold">Dr.Vasishth’s AyuRemedies</Text>
              <Text mt="10px" variant="contactUsRegular">
                A-3, Phase II, Road 9, Gallops Industrial Park, Vasna,
                Chacharwadi Ta. Sanand, Dist. Ahmedabad, Gujarat 382213
              </Text>
            </Flex>
            <Flex
              flexDirection="column"
              mt="10px"
              width={{ base: "100%", md: "48%" }}
            >
              <Text variant="contactUsBold">Phone Number</Text>
              <Text mt="10px" variant="contactUsRegular">
                Office: +91-9998002862 / 9426065439 / 9998005850
              </Text>
              <Text mt="10px" variant="contactUsBold">
                Email Id
              </Text>
              <Text mt="10px" variant="contactUsRegular">
                online@drvasishths.com
              </Text>
            </Flex>
          </Flex>

          <Flex
            flexDirection="column"
            mt={{ base: "10", xl: "0" }}
            width={{ base: "100%", xl: "48%" }}
            justifyContent={{ base: "flex-start", md: "space-between" }}
          >
            <LocationMap height="100%" />
          </Flex>

          <Flex
            mt={5}
            width="100%"
            d={{ xl: "none" }}
            height={{ base: "300px", sm: "350px", md: "400px" }}
          >
            <LocationMap height="100%" />
          </Flex>
        </Flex>
      </Center>
    </>
  );
}

export const getStaticProps = wrapper.getStaticProps((store) => async () => {
  try {
    await store.dispatch(fetchProductCategories());
  } catch (err) {
    return {
      props: {
        errorMessage: err.message,
      },
    };
  }
});
